import type { Entry } from 'contentful';

import { TypeMarketSkeleton } from '../models/cms';
import { Image, MarketData } from '../models';

import { transformHeader } from './transformHeader.ts';
import { transformFooter } from './transformFooter.ts';

export const transformMarket = (skeleton: Entry<TypeMarketSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>): MarketData => {
  if (!skeleton.fields.image) {
    throw new Error(`Expected an image in market: '${skeleton.sys.id}'`);
  }

  const image = {
    title: skeleton.fields.image.fields.title,
    description: skeleton.fields.image.fields.description,
    url: skeleton.fields.image.fields.file?.url,
  } as Image;

  if (!skeleton.fields.header) {
    throw new Error(`Expected a header in market: '${skeleton.sys.id}'`);
  }

  if (!skeleton.fields.footer) {
    throw new Error(`Expected a footer in market: '${skeleton.sys.id}'`);
  }

  return {
    id: skeleton.fields.id,
    name: skeleton.fields.name,
    shortLabel: skeleton.fields.shortLabel,
    image,
    thirdPartyUrl: skeleton.fields.thirdPartyUrl,
    header: transformHeader(skeleton.fields.header),
    footer: transformFooter(skeleton.fields.footer),
  };
};
